import { render, staticRenderFns } from "./NetaMultiEventDetailsView.vue?vue&type=template&id=de794c8a&scoped=true&"
import script from "./NetaMultiEventDetailsView.vue?vue&type=script&lang=js&"
export * from "./NetaMultiEventDetailsView.vue?vue&type=script&lang=js&"
import style0 from "./NetaMultiEventDetailsView.vue?vue&type=style&index=0&id=de794c8a&lang=scss&scoped=true&"
import style1 from "./NetaMultiEventDetailsView.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "de794c8a",
  null
  
)

export default component.exports